import { CountryDto } from 'gleblu-socket-api';

import Country from '../interfaces/Country';

export function fromDto(company: CountryDto): Country {
  const { uuid, nameRo, nameHu, nameEn, isoCode } = company;
  return {
    uuid,
    nameRo,
    nameHu,
    nameEn,
    isoCode,
  };
}

export function toDto(company: Country): CountryDto {
  const { uuid, nameRo, nameHu, nameEn, isoCode } = company;
  return {
    uuid,
    nameRo,
    nameHu,
    nameEn,
    isoCode,
  };
}
